export enum DetailsSheetVariant {
  ViewOnly_NoPending = "ViewOnly_NoPending",
  ViewOnly_AI = "ViewOnly_AI",
  ViewOnly_ManualOther = "ViewOnly_ManualOther",

  Contributor_NoPending = "Contributor_NoPending",
  Contributor_AI = "Contributor_AI",
  Contributor_ManualOwn = "Contributor_ManualOwn",
  Contributor_ManualOther = "Contributor_ManualOther",

  Admin_NoPending = "Admin_NoPending",
  Admin_AI = "Admin_AI",
  Admin_Manual = "Admin_Manual",
}

export type DetailsStatus = "approved" | "pending";

export type PendingCardVM = {
  visible: boolean;
  showsApproveDecline: boolean;
  showsDeactivateInsideCard: boolean;
};

export type DetailsSheetViewModel = {
  /** Enables copy/paste of the approved translation. */
  pasteEnabled: boolean;

  /** Shows the pencil (edit) icon next to the translated value. */
  editIconVisible: boolean;

  /** Overall record state derived from history (approved|pending). */
  status: DetailsStatus;

  /** Pending/suggestion card visibility and controls. */
  pendingCard: PendingCardVM;

  /** Shows the outer “Deactivate” action in the main area. */
  outerDeactivateVisible: boolean;

  /** Buttons for the English String info dialog. */
  dialogButtons: ReadonlyArray<"SubmitNewString" | "Close">;

  /** Variant from role + history (for QA/telemetry; don’t branch UI on this). */
  variant: DetailsSheetVariant;

   /** Optional: inner Deactivate button inside the pending card */
    showsDeactivateInsideCard?: boolean;
};

export const PENDING = {
  None: "none",
  AI: "ai",
  Manual: "manual",
} as const;
export type PendingType = typeof PENDING[keyof typeof PENDING];